import { useState, type FormEvent } from 'react';
import {
  useToolCall, PlatformSelect, GenerateButton, CopyButton, LimitReached, ResultFunnel, ErrorNote,
  type ToolPlatform,
} from './aiToolShared';

const TONES = ['cercano y profesional', 'divertido', 'inspirador', 'directo y persuasivo', 'elegante'];

export function CaptionGenerator() {
  const [topic, setTopic] = useState('');
  const [platform, setPlatform] = useState<ToolPlatform>('instagram');
  const [tone, setTone] = useState(TONES[0]);
  const { run, loading, error, limitReached, data } = useToolCall<{ caption: string; hashtags: string[] }>('/api/tools/caption');

  function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (topic.trim().length < 2) return;
    run({ topic: topic.trim(), platform, tone });
  }

  const full = data ? [data.caption, data.hashtags.join(' ')].filter(Boolean).join('\n\n') : '';

  return (
    <div>
      <form onSubmit={onSubmit} className="space-y-4">
        <label className="block">
          <span className="text-sm font-medium text-slate-700">¿De qué trata tu publicación?</span>
          <textarea
            value={topic}
            onChange={(e) => setTopic(e.target.value)}
            rows={3}
            maxLength={600}
            placeholder="Ej.: lanzamiento de nuestra nueva colección de verano con 20% de descuento"
            className="mt-1 w-full rounded-xl border border-slate-300 p-3.5 text-slate-900 focus:border-brand-500 focus:ring-2 focus:ring-brand-200 outline-none resize-y"
          />
        </label>
        <div className="flex flex-wrap items-end gap-4">
          <PlatformSelect value={platform} onChange={setPlatform} />
          <label className="block">
            <span className="text-sm font-medium text-slate-700">Tono</span>
            <select
              value={tone}
              onChange={(e) => setTone(e.target.value)}
              className="mt-1 block rounded-lg border border-slate-300 px-3 py-2 text-sm text-slate-900 focus:border-brand-500 focus:ring-2 focus:ring-brand-200 outline-none"
            >
              {TONES.map((t) => <option key={t} value={t}>{t}</option>)}
            </select>
          </label>
        </div>
        <GenerateButton loading={loading} label="Generar caption" />
      </form>

      {error && <ErrorNote message={error} />}
      {limitReached && <div className="mt-6"><LimitReached /></div>}

      {data && data.caption && !limitReached && (
        <ResultFunnel>
          <div className="rounded-xl border border-slate-200 bg-white p-4">
            <div className="flex items-center justify-end">
              <CopyButton text={full} />
            </div>
            <p className="mt-2 text-slate-800 whitespace-pre-wrap leading-relaxed">{data.caption}</p>
            {data.hashtags.length > 0 && (
              <p className="mt-3 text-sm text-brand-700">{data.hashtags.join(' ')}</p>
            )}
          </div>
        </ResultFunnel>
      )}
    </div>
  );
}
